import { Component, OnInit, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FileDoc, FileUploadService } from 'src/app/core/components';
import { DatePipe } from '@angular/common';
import { VisitorManagementService } from '../visitor-management.service';
import { FormControl, FormGroup } from '@angular/forms';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { GLOBAL } from 'src/app/app.globals';
import { SharedService } from 'src/app/core/services';
import { IndiaMapService } from 'src/app/dashboard/charts/india-map.service';
import { GroupBarChartService } from 'src/app/dashboard/charts/group-bar-chart.service';
import { BarChartService } from 'src/app/dashboard/charts/bar-chart.service';
import { VisitorFormModalComponent } from '../visitor-form-modal/visitor-form-modal.component';
import { VerifyVisitorComponent } from '../verify-visitor/verify-visitor.component';
import { AppQrCodeService } from 'src/app/core/components/app-qr-code/app-qr-code.service';
import { ApiCallService } from 'src/app/service/api-call.service';
import { RequestVisitorFormModalComponent } from '../request-visitor/request-visitor-form-modal.component';
import { BarcodeFormat } from '@zxing/library';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { ActivatedRoute } from '@angular/router';

declare var d3: any;
declare var crossfilter: any;
declare var dc: any;
declare var $: any;
declare var chroma: any;
@Component({
  selector: 'app-visitor-dashboard',
  templateUrl: './visitor-dashboard.component.html',
  styleUrls: ['./visitor-dashboard.component.css']
})

export class VisitorDashboardComponent implements OnInit {
  @ViewChild('tempRef') public tempRef: any;
  @ViewChild('uploadDocumentTemplateRef') public uploadDocumentTemplateRef: any;
  @ViewChild('tempRef1') public tempRef1: any;
  @ViewChild('scanSerialTemplate') public scanQrTemplate: any;
  @ViewChild('qrScanner') qrScanner: ZXingScannerComponent;
  modalRef: NgbModalRef;
  allData: any;
  allPreAuthorizedData: any;
  activityData: any;
  pcountries = [];
  pStates = [];
  pDistricts = [];
  pCities = [];
  pPos = [];
  pVillages = [];
  visitorcategory: any;
  visitorpurposetypeList: any;
  identityTypes: any;
  statusType: any;
  show = false;
  showdrivinglicence = false;
  showelectioncard = false;
  masterData = [];
  gendertypes: any;
  iteamtypes: any;
  iteamsViews = [];
  hideUpdateiteams = true;
  edititeamsIndex = -1;
  mycolor: string;
  // tslint:disable-next-line: variable-name
  OtherPersonDetailViews = [];
  hideUpdateOtherPerson = true;
  editipersonIndex = -1;
  documentTypes = [];
  selectedRowData: any[] = [];
  uploadedFiles: FileDoc[] = [];
  public companyMasterData: any[] = [];
  public plantMasterData: any[] = [];
  public shiftGroupTypeData: any[] = [];
  public companyMasterModel: any;
  public plantMasterModel: any;
  public companyData: any[] = [];
  public units: any[] = [];
  public plants: any[] = [];
  public datePickerPlaceHolder: string;
  public datePickerPickerMode: string;
  croppedImage: any = '';
  savedCroppedImage: any = '';
  editshiftCode1: string;
  editMode = false;
  teashow = false;
  shiftname: any;
  shortCode: any;
  shortname: any;
  data: any;
  allEmployeeData: any;
  earlyallowedouthours = 0;
  isactive = true;
  issuedate = false;
  optionsChecked = [];
  visitorCode: any;
  totalTodayVisitor: any;
  totalCurrentMonthVisitor: any;
  totalLastMonthVisitor: any;
  totalCurrentYearVisitor: any;
  // tslint:disable-next-line: variable-name
  employee_Code: any;
  public activeref: any;
  barTotalMonthlyVisitors;
  barTotalweeklyVisitors;
  spanTotalMale;
  spanTotalFemale;
  userId = localStorage.getItem('UserID');
  scannerEnabled = false;
  scannerFormats: BarcodeFormat[] = [BarcodeFormat.QR_CODE];
  hasDevices: boolean | null = null;
  hasPermission: boolean | null = null;
  scannerError = '';
  availableDevices: MediaDeviceInfo[] = [];
  selectedDevice: MediaDeviceInfo | null = null;

  visitorForm = new FormGroup({
    Company_Code: new FormControl(''),
    Plant_Code: new FormControl(''),
    Unit_Code: new FormControl(''),
    Department_Code: new FormControl(''),
    yourcompany: new FormControl(''),
    name: new FormControl(''),
    jobtitle: new FormControl(''),
    mobileno: new FormControl(''),
    emailid: new FormControl(''),
    otp: new FormControl(''),
    emergencycontactname: new FormControl(''),
    emergencycontactno: new FormControl(''),
    address: new FormControl(''),
    address1: new FormControl(''),
    zipcode: new FormControl(''),
    PCountry_Code: new FormControl(''),
    PState_Code: new FormControl(''),
    PDistrict_Code: new FormControl(''),
    PCity_Code: new FormControl(''),
    PPostOffice_Code: new FormControl(''),
    LVillage_Code: new FormControl(''),
    visitorcategoryasterList_Code: new FormControl(''),
    TypeOfIdentityMasterItem_Code: new FormControl(''),
    addharNo: new FormControl(''),
    drvingLicense: new FormControl(''),
    electionCard: new FormControl(''),
    breanginglaptop1: new FormControl(''),
    date: new FormControl(''),
    starttime: new FormControl(''),
    Enddate: new FormControl(''),
    endtime: new FormControl(''),
    actualdate: new FormControl(''),
    actualtime: new FormControl(''),
    temp: new FormControl(''),
    totannumber: new FormControl(''),
    lockernumber: new FormControl(''),
    visitorpurposeMasterList_Code: new FormControl(''),
    purposeofvisit1: new FormControl(''),
    mobileallowed: new FormControl(''),
    havematchbox: new FormControl(''),
    laptopallowed: new FormControl(''),
    havetoolkit: new FormControl(''),
    name1: new FormControl(''),
    identitytype: new FormControl(''),
    mobilenumber: new FormControl(''),
    pemailid: new FormControl(''),
    pjobtitle: new FormControl(''),
    Gender: new FormControl(''),
    ptemp: new FormControl(''),
    iteamtype: new FormControl(''),
    iteamdescription: new FormControl(''),
    serialno: new FormControl(''),
    isreturnable: new FormControl(''),
  });
  employeeDetailForm = new FormGroup({
  });
  docForm = new FormGroup({
  });

  constructor(
    private sharedService: SharedService,
    private visitorManagementService: VisitorManagementService,
    public sharedDataService: SharedDataService,
    public fileUploadService: FileUploadService,
    private logHelperService: LogHelperService,
    private cookieService: CookieService,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private indiaMapService: IndiaMapService,
    private groupBarChartService: GroupBarChartService,
    private barChartService: BarChartService,
    private appQrCodeService: AppQrCodeService,
    private apiCall: ApiCallService,
    private route: ActivatedRoute
  ) {
    this.datePickerPlaceHolder = this.sharedService.datePickerSettings.placeHolder;
    this.datePickerPickerMode = this.sharedService.datePickerSettings.pickerMode;

  }

  ngOnInit() {
    this.getDataSet();
    this.getVisitorTimeLineDashboard();
    this.getVisitorPreAuthorizedDashboard();
    this.getVisitorActivityDashboard(null);
    this.getCompanyData();
    this.getPlants();
    this.getUnits();
    this.getCountry();
    this.gettotalcount();
    // this.startCamera();
    this.apiCall.getDocumentTypes().subscribe((response: any) => {
      this.documentTypes = response.Data;
    });

    this.sharedService.getMasterData().subscribe((masterList: any) => {
      //
      console.log('master data', masterList);
      this.masterData = (masterList && masterList.Data && masterList.Data.Table) ? masterList.Data.Table : [];

      this.visitorcategory = this.masterData.filter(list => list.Parent_Code === 968);
      // this.visitorpurposetypeList = this.masterData.filter(list => list.Parent_Code === 976);
      // this.gendertypes = this.masterData.filter(list => list.Parent_Code === 302);
      // this.iteamtypes = this.masterData.filter(list => list.Parent_Code === 983);
      this.identityTypes = [
        { Id: 1, Name: 'Aadhar Card' },
        { Id: 2, Name: 'Driving License' },
        { Id: 3, Name: 'Election Card' }
      ];
      this.statusType = [
        { Id: 1, Name: 'Approved' },
        { Id: 2, Name: 'Reject' },
      ];
    });

    // Handle query params from header buttons
    this.route.queryParams.subscribe(params => {
      if (params['action']) {
        switch(params['action']) {
          case 'request-visitor':
            this.requestVisitor();
            break;
          case 'read-qr':
            this.readQrCode();
            break;
          case 'verify-visitor':
            this.verifyVisitor();
            break;
          case 'add-visitor':
            this.openModal();
            break;
        }
      }
    });
  }

  formatTime(time: string): string {
    if (!time) return '';
    const parts = time.split(':');
    if (parts.length >= 2) {
      return `${parts[0]}:${parts[1]}`;
    }
    return time;
  }

  getDataSet() {
    const reqObj = {
      RequireType: 0,
      ActionType: 0,
      SelectedFild: null,
      UserId: this.userId
    }
    this.visitorManagementService.getDataSet(reqObj).subscribe(response => {
      this.bindChart(response);
      this.calculateYearlyTotal(response);
    });
  }

  bindChart(dataReal) {
    const ndx1 = crossfilter(dataReal);
    this.visitorManagementService.getIndiaJson().subscribe((response) => {
      this.indiaMapService.generatemap(ndx1, response);
    });
    this.barTotalMonthlyVisitors = this.barChartService.barTotalMonthlyVisitors({
      crossfilter: ndx1,
      filterGroup: 'group1',
      chartId: '#barTotalMonthlyVisitors',
      groupByProperty: null,
      reduceProperty: null,
      width: 400,
      height: 200,
      gap: 4,
      yAxisLabel: 'Total',
      xAxisLabel: 'Month',
      elasticX: true,
      elasticY: true,
    });

    this.barTotalweeklyVisitors = this.barChartService.barTotalweeklyVisitors({
      crossfilter: ndx1,
      filterGroup: 'group1',
      chartId: '#barTotalweeklyVisitors',
      groupByProperty: null,
      reduceProperty: null,
      width: 280,
      height: 150,
      gap: 4,
      yAxisLabel: 'Total',
      xAxisLabel: 'day',
      elasticX: true,
      elasticY: true,
    });

    this.spanTotalMale = this.getCountChartGender(ndx1, '#spanTotalMale', true, false);
    this.spanTotalFemale = this.getCountChartGender(ndx1, '#spanTotalFemale', false, true);
  }

  getCountChartGender(ndx1, chartId, isMale, isFemale) {
    const chart = dc.numberDisplay(chartId, 'group1');
    const group = ndx1.groupAll().reduceSum((d) => {
      let cnt = 0;
      if (isMale && (d.Gender === 'Male' || d.Gender === 'MALE')) {
        cnt++;
      }

      if (isFemale && (d.Gender === 'Female' || d.Gender === 'FEMALE')) {
        cnt++;
      }
      return cnt;
    });

    chart
      .formatNumber(d3.format('.'))
      // .dimension(dimension)
      .valueAccessor(d => d)
      .group(group);
    chart.render();
    return chart;
  }

  getVisitorTimeLineDashboard() {
    const reqObj = {
      RequireType: 0,
      ActionType: 0,
      SelectedFild: null,
      UserId: this.userId
    }
    this.visitorManagementService.VisitorTimeLineDashboard(reqObj).subscribe((response: any) => {
      this.allData = response;
    });
  }

  gettotalcount() {
    this.visitorManagementService.gettotalcount().subscribe((res: any) => {
      if (res && res.length > 0) {
        this.totalTodayVisitor = res[0].TotalTodayVisitor || 0;
        this.totalCurrentMonthVisitor = res[0].TotalCurrentMonthVisitor || 0;
        this.totalLastMonthVisitor = res[0].TotalLastMonthVisitor || 0;
      }
    });
  }

  calculateYearlyTotal(data: any[]) {
    const currentYear = new Date().getFullYear();
    this.totalCurrentYearVisitor = data.filter(visitor => {
      const visitDate = new Date(visitor.StartDate || visitor.Date || visitor.CreatedDate);
      return visitDate.getFullYear() === currentYear;
    }).length;
  }

  getVisitorPreAuthorizedDashboard() {
    const reqObj = {
      RequireType: 0,
      ActionType: 0,
      SelectedFild: null,
      UserId: this.userId
    }
    this.visitorManagementService.VisitorPreAuthorizedDashboard(reqObj).subscribe((response: any) => {
      this.allPreAuthorizedData = response;
    });
  }

  SignIn(data) {
    console.log('Clicked visitor:', data);
    this.activityData = [data];
  }

  getVisitorActivityDashboard(data: any) {
    console.log('Fetching activity for Visitor_Code:', data);
    this.visitorManagementService.VisitorActivityDashboard(data).subscribe((response: any) => {
      console.log('Activity data received:', response);
      this.activityData = response;
    });
  }

  public openModal(): void {
    this.clearData();
    this.activeref = this.modalService.open(VisitorFormModalComponent,
      { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' });
    this.activeref.componentInstance.genderTypes = this.gendertypes;
    this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].setValue(1);
    this.show = true;
  }

  saveCroppedImage(): void {
    this.savedCroppedImage = this.croppedImage;
    this.modalRef.close();
  }

  private clearData() {
    this.visitorForm.reset();
    this.employeeDetailForm.reset();
    this.teashow = false;
    this.show = false;
  }

  public onCancel(): void {
    this.modalRef.close('click');
    this.clearData();
  }

  public onCloseModel(): void {
    this.clearData();
    this.modalRef.close('click');
  }

  public onvisitordetail(): void {
    this.clearData();
    this.activeref.close('click');
  }

  changeIdentitytype() {
    if (this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].value === 1) {
      this.show = true;
      this.showdrivinglicence = false;
      this.showelectioncard = false;
    }
    if (this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].value === 2) {
      this.showdrivinglicence = true;
      this.show = false;
      this.showelectioncard = false;
    }
    if (this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].value === 3) {
      this.showelectioncard = true;
      this.showdrivinglicence = false;
      this.show = false;
    }
  }
  // tslint:disable-next-line: function-name
  UploadDoc(): void {

    this.modalRef = this.modalService.open(this.uploadDocumentTemplateRef,
      { size: 'lg', backdrop: 'static', keyboard: false });
  }
  // tslint:disable-next-line: function-name
  Host() {
    this.modalRef = this.modalService.open(this.tempRef1,
      { size: 'lg', backdrop: 'static' });
    this.employeeDetail();
  }
  public onCloseAproval(): void {
    this.clearData();
    this.selectedRowData = [];
    this.modalRef.close('click');
  }
  employeeDetail() {

    return this.visitorManagementService.getEmployeeDetail().subscribe((res: any) => {
      this.allEmployeeData = res;
    });
  }
  getCompanyData() {
    return this.visitorManagementService.getCompanyMasterData().subscribe((response: any) => {
      this.companyData = response;
      if (this.companyData.length === 1) {
        // this.labourForm.control.value.Company;
        this.visitorForm.controls['Company_Code'].setValue(this.companyData[0].Company_Code);

      } else {
        this.companyData = response;
      }
    });
  }

  getPlants() {
    return this.visitorManagementService.getPlantMasterData().subscribe((res: any) => {
      this.plants = res;
      if (this.plants.length === 1) {
        this.visitorForm.controls['Plant_Code'].setValue(this.plants[0].Plant_Code);
      } else {
        this.plants = res;
      }
    });
  }

  getUnits() {

    return this.visitorManagementService.getUnitMasterData(this.visitorForm.controls['Plant_Code'].value || 100).subscribe((res: any) => {
      this.units = res.Data.Table;
      if (this.units.length === 1) {
        this.visitorForm.controls['Unit_Code'].setValue(this.units[0].Unit_Code);
      } else {
        this.units = res.Data.Table;
      }
    });
  }
  getCountry() {
    return this.visitorManagementService.getCountry().subscribe((response: any) => {
      this.pcountries = response;
    });
  }

  getStatesByCountryIdP() {

    return this.visitorManagementService.getStatesByCountryId(this.visitorForm.controls['PCountry_Code'].value || 100)
      .subscribe((response: any) => {
        this.pStates = response;
      });
  }
  getDistrictsByStateP() {
    this.visitorManagementService.getDistrictsByState(this.visitorForm.controls['PState_Code'].value || 100).subscribe((response: any) => {
      this.pDistricts = response;
    });
  }

  getCitiesByDistrictP() {
    this.visitorManagementService.
      getCitiesByDistrict(this.visitorForm.controls['PDistrict_Code'].value || 100)
      .subscribe((response: any) => {
        this.pCities = response;
      });
  }
  getPostOfficeByCityP() {
    this.visitorManagementService.getPOsByCity(this.visitorForm.controls['PCity_Code'].value || 100).subscribe((res: any) => {
      this.pPos = res;
    });
  }
  getVillageP() {
    // tslint:disable-next-line: max-line-length
    this.visitorManagementService.getVillageByPostOffice(this.visitorForm.controls['PPostOffice_Code'].value || 100).subscribe((response: any) => {
      this.pVillages = response;
    });
  }


  // tslint:disable-next-line: function-name
  AddIteams(index?: number) {

    if (typeof index !== 'undefined') {
      this.iteamsViews[index] = {
        ItemTypeMasterItem_Code: this.visitorForm.controls.iteamtype.value,
        ItemDescription: this.visitorForm.controls.iteamdescription.value,
        SerialNo: this.visitorForm.controls.serialno.value,
        IsReturnableIteam: this.visitorForm.controls.isreturnable.value,
      };
      this.visitorForm.controls['iteamtype'].reset();
      this.visitorForm.controls['iteamdescription'].reset();
      this.visitorForm.controls['serialno'].reset();
      this.visitorForm.controls['isreturnable'].reset();
    } else {
      this.iteamsViews.push({
        ItemTypeMasterItem_Code: this.visitorForm.controls.iteamtype.value,
        ItemDescription: this.visitorForm.controls.iteamdescription.value,
        SerialNo: this.visitorForm.controls.serialno.value,
        IsReturnableIteam: this.visitorForm.controls.isreturnable.value,
      });
      this.visitorForm.controls['iteamtype'].reset();
      this.visitorForm.controls['iteamdescription'].reset();
      this.visitorForm.controls['serialno'].reset();
      this.visitorForm.controls['isreturnable'].reset();
    }
    return;

  }

  edititeams(index) {
    this.edititeamsIndex = index;
    this.hideUpdateiteams = false;
    this.visitorForm.controls['iteamtype'].setValue(this.iteamsViews[index].ItemTypeMasterItem_Code);
    this.visitorForm.controls['iteamdescription'].setValue(this.iteamsViews[index].ItemDescription);
    this.visitorForm.controls['serialno'].setValue(this.iteamsViews[index].SerialNo);
    this.visitorForm.controls['isreturnable'].setValue(this.iteamsViews[index].IsReturnableIteam);
  }

  updateiteams() {
    this.AddIteams(this.edititeamsIndex);
  }

  deleteiteams(index) {
    this.iteamsViews.splice(index, 1);
    this.hideUpdateiteams = true;
  }



  // tslint:disable-next-line: function-name
  AddOtherPersonDetail(index?: number) {

    if (typeof index !== 'undefined') {
      this.OtherPersonDetailViews[index] = {
        Name: this.visitorForm.controls.name1.value,
        pjobtitle: this.visitorForm.controls.pjobtitle.value,
        mobilenumber: this.visitorForm.controls.mobilenumber.value,
        Gender: this.visitorForm.controls.Gender.value,
        ptemp: this.visitorForm.controls.ptemp.value,
      };
      this.visitorForm.controls['name1'].reset();
      this.visitorForm.controls['pjobtitle'].reset();
      this.visitorForm.controls['mobilenumber'].reset();
      this.visitorForm.controls['Gender'].reset();
      this.visitorForm.controls['ptemp'].reset();

    } else {
      this.OtherPersonDetailViews.push({
        Name: this.visitorForm.controls.name1.value,
        JobTitle: this.visitorForm.controls.pjobtitle.value,
        MobileNo: this.visitorForm.controls.mobilenumber.value,
        GenderMasterItem_Code: this.visitorForm.controls.Gender.value,
        Temperature: this.visitorForm.controls.ptemp.value,
        EmailID: this.visitorForm.controls.pemailid.value,
        IdentityType_Code: this.visitorForm.controls.identitytype.value,

      });
      this.visitorForm.controls['name1'].reset();
      this.visitorForm.controls['pjobtitle'].reset();
      this.visitorForm.controls['mobilenumber'].reset();
      this.visitorForm.controls['Gender'].reset();
      this.visitorForm.controls['ptemp'].reset();
      this.visitorForm.controls['pemailid'].reset();
      this.visitorForm.controls['identitytype'].reset();
    }
    return;

  }

  editiperson(index) {
    this.editipersonIndex = index;
    this.hideUpdateOtherPerson = false;
    this.visitorForm.controls['name1'].setValue(this.OtherPersonDetailViews[index].Name);
    this.visitorForm.controls['pjobtitle'].setValue(this.OtherPersonDetailViews[index].JobTitle);
    this.visitorForm.controls['mobilenumber'].setValue(this.OtherPersonDetailViews[index].MobileNo);
    this.visitorForm.controls['Gender'].setValue(this.OtherPersonDetailViews[index].GenderMasterItem_Code);
    this.visitorForm.controls['ptemp'].setValue(this.OtherPersonDetailViews[index].Temperature);
    this.visitorForm.controls['pemailid'].setValue(this.OtherPersonDetailViews[index].EmailID);
    this.visitorForm.controls['identitytype'].setValue(this.OtherPersonDetailViews[index].IdentityType_Code);
  }

  updateiPersonDetail() {
    this.AddOtherPersonDetail(this.editipersonIndex);
  }

  deleteperson(index) {
    this.OtherPersonDetailViews.splice(index, 1);
    this.hideUpdateOtherPerson = true;
  }
  // tslint:disable-next-line: function-name
  IsCheck(item, event) {

    this.allData[item] = event.target.checked;
    if (this.allData[item] === true) {
      if (this.optionsChecked.indexOf(item.Employee_Code) === -1) {
        this.optionsChecked.push(item.Employee_Code);

      } else {
        this.optionsChecked.splice(this.optionsChecked.indexOf(item.Employee_Code), 1);
      }
    } else {
      this.optionsChecked.splice(this.optionsChecked.indexOf(item.Employee_Code), 1);

    }
  }
  // tslint:disable-next-line: function-name
  public SubmitRequest(): void {

    console.log('form data open modal', this.visitorForm.getRawValue());
    const value = this.visitorForm.getRawValue();
    const value1 = this.employeeDetailForm.getRawValue();
    if (this.optionsChecked.length > 0 && this.optionsChecked.length <= 1) {
      const data: any = {
        Shift_Code: this.editshiftCode1,
        Company_Code: value.Company_Code,
        Plant_Code: value.Plant_Code,
        Unit_Code: value.Unit_Code,
        Department_Code: value.Department_Code,
        VisitorCompany: value.yourcompany,
        FullName: value.name,
        JobTitle: value.jobtitle,
        MobileNo: value.mobileno,
        EmailID: value.emailid,
        OTP: value.otp,
        EmergancyContactName: value.emergencycontactname,
        EmergancyContactNo: value.emergencycontactno,
        Address1: value.address,
        Address2: value.address1,
        ZipCode: value.zipcode,
        Country_Code: value.PCountry_Code,
        State_Code: value.PState_Code,
        District_Code: value.PDistrict_Code,
        City_Code: value.PCity_Code,
        PostOffice_Code: value.PPostOffice_Code,
        Village_Code: value.LVillage_Code,
        VisitorCategory_Code: value.visitorcategoryasterList_Code,
        IDProofType_Code: value.TypeOfIdentityMasterItem_Code,
        AddharNo: value.addharNo,
        DrivingLicenceNo: value.drvingLicense,
        ElectionCardNo: value.electionCard,
        BringLaptop: value.breanginglaptop1,
        StartTime: value.starttime,
        StartDate: value.date,
        EndDate: value.Enddate,
        EndTime: value.endtime,
        ActualDate: value.actualdate,
        ActualTime: value.actualtime,
        Temperature: value.temp,
        TokenNumber: value.totannumber,
        LockerNumber: value.lockernumber,
        VisitorPurposeType_Code: value.visitorpurposeMasterList_Code,
        Visitorpurpose: value.purposeofvisit1,
        HaveMobile: value.mobileallowed,
        HaveToolkit: value.havetoolkit,
        HaveLaptop: value.laptopallowed,
        HaveMatchBox: value.havematchbox,
        CreatedBy: localStorage.getItem('UserID'),
        RoleCode: JSON.parse(localStorage.getItem('Role'))[0].Role_Code,
        RequestRefCode: this.optionsChecked,
        OtherPersonDetailViews: this.OtherPersonDetailViews,
        iteamsViews: this.iteamsViews,
      };
      const uploadParams = {
        Visitor_Code: ''
      };
      // if (selectedFilterDataObj)
      // tslint:disable-next-line: brace-style
      {
        this.apiCall.apiCommonInsertUpdate(data).subscribe((response: any) => {
          uploadParams.Visitor_Code = response.Data;
          if (uploadParams.Visitor_Code) {
            this.fileUploadService.uploadFiles(this.uploadedFiles, uploadParams, GLOBAL.APIS.VISITOR_MANAGEMENT.UPLOAD_DOC)
              .subscribe((res) => {
                this.logHelperService.logSuccess({
                  message: 'Request Submitted successfully'
                });
                this.getVisitorTimeLineDashboard();
                this.getVisitorPreAuthorizedDashboard();
                this.getVisitorActivityDashboard(null);
                this.docForm.reset();
                this.clearData();
                this.modalRef.close();
                this.activeref.close();
                this.docForm.reset();
              });
          }
          this.logHelperService.logSuccess({
            message: 'Request Submitted successfully'
          });
          this.getVisitorTimeLineDashboard();
          this.getVisitorPreAuthorizedDashboard();
          this.getVisitorActivityDashboard(null);
          this.clearData();
          this.modalRef.close();
          this.activeref.close();
          this.docForm.reset();
        });
      }
    } else {
      this.logHelperService.logError({
        message: 'Please Select Only One Employee '
      });
    }
  }

  // tslint:disable-next-line: function-name
  CheckOut(activity) {

    this.visitorManagementService.cheout(activity.Visitor_Code).subscribe((response: any) => {
      this.logHelperService.logSuccess({
        message: 'Successfully Updated'
      });
      this.getVisitorTimeLineDashboard();
      this.getVisitorActivityDashboard(null);
    });
  }

  verifyVisitor() {
    this.activeref = this.modalService.open(VerifyVisitorComponent,
      { size: 'lg', backdrop: 'static' });
  }

  requestVisitor() {
   this.clearData();
    this.activeref = this.modalService.open(RequestVisitorFormModalComponent,
      { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' });
    this.activeref.componentInstance.genderTypes = this.gendertypes;
    this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].setValue(1);
    this.show = true;
  }

  readQrCode() {
    this.openQrScanner();
  }

  openQrScanner() {
    debugger
    this.scannerEnabled = true;
    this.scannerError = '';
    this.hasDevices = null;
    this.hasPermission = null;
    this.availableDevices = [];
    this.selectedDevice = null;
    this.modalRef = this.modalService.open(this.scanQrTemplate,
      { size: 'lg', backdrop: 'static', keyboard: true, windowClass: 'modal-scrollbar-hide' });
    this.modalRef.result.then(
      () => { this.scannerEnabled = false; },
      () => { this.scannerEnabled = false; }
    );
  }
  

  onQrScan(resultString: string) {
    debugger
    if (!resultString) {
      return;
    }
    this.scannerEnabled = false;
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.handleScannedQrData(resultString);
  }

  onQrCamerasFound(devices: MediaDeviceInfo[]) {
    this.availableDevices = devices || [];
    this.hasDevices = this.availableDevices.length > 0;
    if (this.availableDevices.length > 0) {
      this.selectedDevice = this.availableDevices[0];
    }
  }

  onQrCamerasNotFound() {
    this.hasDevices = false;
    this.scannerError = 'No camera devices found.';
  }

  onQrPermissionResponse(hasPermission: boolean) {
    this.hasPermission = hasPermission;
    if (!hasPermission) {
      this.scannerError = 'Camera permission denied. Please allow camera access.';
    }
  }

  onQrScanError(error: any) {
    this.scannerError = error ? String(error) : 'Scanner error';
  }

  private handleScannedQrData(scannedValue: string) {
    debugger
    const parsedPayload = this.parseQrPayload(scannedValue);

    if (parsedPayload == null) {
      this.logHelperService.logError({ message: 'Invalid QR data format.' });
      return;
    }

    const visitorCode = this.extractVisitorCode(parsedPayload);
    if (visitorCode != null) {
      this.bindVisitorFromId(visitorCode);
      return;
    }

    if (typeof parsedPayload === 'object') {
      const prefillData = this.mapQrPrefillToModalForm(parsedPayload);
      const prefillItems = this.mapQrItems(parsedPayload);
      this.openVisitorModalWithPrefill(prefillData, prefillItems);
      this.logHelperService.logSuccess({ message: 'QR data loaded successfully.' });
      return;
    }

    this.logHelperService.logError({ message: 'QR data does not contain valid visitor details.' });
  }

  private parseQrPayload(scannedValue: string): any {
    const trimmed = typeof scannedValue === 'string' ? scannedValue.trim() : scannedValue;
    if (trimmed === null || trimmed === undefined || trimmed === '') {
      return null;
    }

    if (typeof trimmed !== 'string') {
      return trimmed;
    }

    if (/^\d+$/.test(trimmed)) {
      return trimmed;
    }

    try {
      const parsed = JSON.parse(trimmed);
      if (parsed && parsed.type === 'visitor_pre_request' && parsed.data) {
        return parsed.data;
      }
      return parsed;
    } catch {
      return null;
    }
  }

  private extractVisitorCode(payload: any): any {
    if (payload === null || payload === undefined) {
      return null;
    }

    if (typeof payload === 'string') {
      return /^\d+$/.test(payload.trim()) ? payload.trim() : null;
    }

    if (typeof payload === 'number') {
      return payload;
    }

    if (typeof payload === 'object') {

  const code =
    payload.Visitor_Code
      ? payload.Visitor_Code
      : (payload.visitorCode
          ? payload.visitorCode
          : (payload.visitor_code
              ? payload.visitor_code
              : (payload.id
                  ? payload.id
                  : (payload.ID ? payload.ID : null))));

  return (code === null || code === undefined || code === '')
    ? null
    : code;
}

    return null;
  }

  private bindVisitorFromId(visitorCode: any) {
    const reqObj = {
      Visitor_Code: this.visitorCode,
      selectedField : null,
      Search :null,
      RequireType : 2,
      ActionType : 0,
    };

    this.apiCall.getAllVisitor(reqObj).subscribe(
      (res: any) => {
        const visitor = Array.isArray(res) && res.length ? res[0] : null;
        if (!visitor) {
          this.logHelperService.logError({ message: 'Visitor data not found for scanned QR id.' });
          return;
        }

        const prefillData = this.mapVisitorResponseToModalForm(visitor);
        this.openVisitorModalWithPrefill(prefillData, []);
        this.logHelperService.logSuccess({ message: 'Visitor data loaded from QR id.' });
      },
      () => {
        this.logHelperService.logError({ message: 'Unable to fetch visitor data from scanned QR id.' });
      }
    );
  }

  private openVisitorModalWithPrefill(prefillData: any, prefillItems: any[]) {
    this.clearData();
    this.activeref = this.modalService.open(VisitorFormModalComponent,
      { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' });
    this.activeref.componentInstance.prefillData = prefillData;
    this.activeref.componentInstance.prefillItems = prefillItems || [];
  }

  private mapQrPrefillToModalForm(qrData: any): any {
  if (!qrData) {
    return {};
  }

  const mapped: any = {
    Company_Code: qrData.Company_Code ? qrData.Company_Code : null,
    Plant_Code: qrData.Plant_Code ? qrData.Plant_Code : null,

    yourcompany: qrData.VisitorCompany
      ? qrData.VisitorCompany
      : (qrData.yourcompany ? qrData.yourcompany : null),

    name: qrData.FullName
      ? qrData.FullName
      : (qrData.name ? qrData.name : null),

    jobtitle: qrData.JobTitle
      ? qrData.JobTitle
      : (qrData.jobtitle ? qrData.jobtitle : null),

    mobileno: qrData.MobileNo
      ? qrData.MobileNo
      : (qrData.mobileno ? qrData.mobileno : null),

    emailid: qrData.EmailID
      ? qrData.EmailID
      : (qrData.emailid ? qrData.emailid : null),

    pgender: qrData.GenderMAsterItem_Code
      ? qrData.GenderMAsterItem_Code
      : (qrData.pgender ? qrData.pgender : null),

    emergencycontactname: qrData.EmergancyContactName
      ? qrData.EmergancyContactName
      : (qrData.emergencycontactname ? qrData.emergencycontactname : null),

    emergencycontactno: qrData.EmergancyContactNo
      ? qrData.EmergancyContactNo
      : (qrData.emergencycontactno ? qrData.emergencycontactno : null),

    address: qrData.Address1
      ? qrData.Address1
      : (qrData.address ? qrData.address : null),

    address1: qrData.Address2
      ? qrData.Address2
      : (qrData.address1
          ? qrData.address1
          : (qrData.landmark ? qrData.landmark : null)),

    zipcode: qrData.ZipCode
      ? qrData.ZipCode
      : (qrData.zipcode ? qrData.zipcode : null),

    PCountry_Code: qrData.Country_Code
      ? qrData.Country_Code
      : (qrData.PCountry_Code ? qrData.PCountry_Code : null),

    PState_Code: qrData.State_Code
      ? qrData.State_Code
      : (qrData.PState_Code ? qrData.PState_Code : null),

    PDistrict_Code: qrData.District_Code
      ? qrData.District_Code
      : (qrData.PDistrict_Code ? qrData.PDistrict_Code : null),

    PCity_Code: qrData.City_Code
      ? qrData.City_Code
      : (qrData.PCity_Code ? qrData.PCity_Code : null),

    PPostOffice_Code: qrData.PostOffice_Code
      ? qrData.PostOffice_Code
      : (qrData.PPostOffice_Code ? qrData.PPostOffice_Code : null),

    visitorcategoryasterList_Code: qrData.VisitorCategoryMIL_Code
      ? qrData.VisitorCategoryMIL_Code
      : (qrData.visitorcategoryasterList_Code
          ? qrData.visitorcategoryasterList_Code
          : null),

    visitorpurposeMasterList_Code: qrData.VisitorPurposeTypeMIL_Code
      ? qrData.VisitorPurposeTypeMIL_Code
      : (qrData.visitorpurposeMasterList_Code
          ? qrData.visitorpurposeMasterList_Code
          : null),

    purposeofvisit1: qrData.Visitorpurpose
      ? qrData.Visitorpurpose
      : (qrData.purposeofvisit1 ? qrData.purposeofvisit1 : null),

    TypeOfIdentityMasterItem_Code: qrData.IDProofTypeMIL_Code
      ? qrData.IDProofTypeMIL_Code
      : (qrData.TypeOfIdentityMasterItem_Code
          ? qrData.TypeOfIdentityMasterItem_Code
          : null),

    addharNo: qrData.AddharNo
      ? qrData.AddharNo
      : (qrData.addharNo ? qrData.addharNo : null),

    drvingLicense: qrData.DrivingLicenceNo
      ? qrData.DrivingLicenceNo
      : (qrData.drvingLicense ? qrData.drvingLicense : null),

    electionCard: qrData.ElectionCardNo
      ? qrData.ElectionCardNo
      : (qrData.electionCard ? qrData.electionCard : null)
  };

  return this.removeUndefined(mapped);
}

  private mapVisitorResponseToModalForm(visitorData: any): any {
    const mapped = {
      Company_Code: visitorData.Company_Code,
      Plant_Code: visitorData.Plant_Code,
      yourcompany: visitorData.VisitorCompany,
      name: visitorData.FullName,
      jobtitle: visitorData.JobTitle,
      mobileno: visitorData.MobileNo,
      emailid: visitorData.EmailID,
      pgender: visitorData.GenderMAsterItem_Code,
      emergencycontactname: visitorData.EmergancyContactName,
      emergencycontactno: visitorData.EmergancyContactNo,
      address: visitorData.Address1,
      address1: visitorData.Address2,
      zipcode: visitorData.ZipCode,
      PCountry_Code: visitorData.Country_Code,
      PState_Code: visitorData.State_Code,
      PDistrict_Code: visitorData.District_Code,
      PCity_Code: visitorData.City_Code,
      PPostOffice_Code: visitorData.PostOffice_Code,
      visitorcategoryasterList_Code: visitorData.VisitorCategoryMIL_Code,
      visitorpurposeMasterList_Code: visitorData.VisitorPurposeTypeMIL_Code,
      purposeofvisit1: visitorData.Visitorpurpose,
      TypeOfIdentityMasterItem_Code: visitorData.IDProofTypeMIL_Code,
      addharNo: visitorData.AddharNo,
      drvingLicense: visitorData.DrivingLicenceNo,
      electionCard: visitorData.ElectionCardNo
    };

    return this.removeUndefined(mapped);
  }

  private mapQrItems(qrData: any): any[] {
    const sourceItems = qrData.Items || qrData.iteamsViews || [];
    if (!Array.isArray(sourceItems)) {
      return [];
    }

    return sourceItems.map((item: any) => ({
      ID: item.ID ? item.ID : null,
      Visitor_Code: item.Visitor_Code ? item.Visitor_Code: null,
      ItemTypeMasterItem_Code: item.ItemTypeMasterItem_Code ? item.ItemTypeMasterItem_Code : item.ItemTypeMIL_Code ? item.ItemTypeMIL_Code : null,
      ItemTypeMasterItem_Name: item.ItemTypeMasterItem_Name ? item.ItemTypeMasterItem_Name : item.ItemTypeName ? item.ItemTypeName : '',
      ItemDescription: item.ItemDescription ? item.ItemDescription: '',
      SerialNo: item.SerialNo ? item.SerialNo :'',
      isreturnable: item.isreturnable ? item.isreturnable : item.IsReturnableIteam === 1
    }));
  }

  private removeUndefined(data: any) {
    const cleaned = {};
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined) {
        cleaned[key] = data[key];
      }
    });
    return cleaned;
  }
}
